interface Carrier {
  name: string
}

export enum SubmissionMethod {
  EMAIL = 'EMAIL',
  CARRIER_PORTAL = 'CARRIER_PORTAL',
}

export enum PaymentMethod {
  ACH = 'ACH',
  CHECK = 'CHECK',
}

interface SlimBroker {
  id: string
  name: string
  bol_submission_method: SubmissionMethod
}

export enum BrokerCarrierRelationshipStatus {
  APPROVAL_PENDING = 'APPROVAL_PENDING',
  APPROVED = 'APPROVED',
  SUSPENDED = 'SUSPENDED',
  DISQUALIFIED = 'DISQUALIFIED',
  INVALID = 'INVALID',
  DNU = 'DNU',
  LIMITED = 'LIMITED',
}

export interface BrokerCarrierRelationship {
  booking_contact_email: string
  booking_contact_phone: string
  booking_types: string[]
  carrier: Carrier
  carrier_agreement: string
  id: string
  is_carrier_packet_complete: boolean
  payment_method: PaymentMethod
  status: BrokerCarrierRelationshipStatus
  status_reason: string
  submission_requirement_notes: string
  support_main_email: string
  support_main_phone: string
  use_support_email_for_tracking: boolean
  is_invoicing_submission_automated: boolean
  broker?: SlimBroker | null
}
